
// Importamos el componente Select desde la carpeta ui
import { Select } from '../../../ui';

// Definimos la interfaz Props que describe las propiedades que recibirá este componente
interface Props {
  value: string;                                         // Valor actual seleccionado
  onChange: (selectedType: string) => void;              // Función que se ejecuta al cambiar la selección
  opciones: string[];                                    // Lista de opciones disponibles para el select
  error: boolean;                                        // Indica si hay un error en la selección
  placeholder: string;                                   // Texto que aparece cuando no hay selección
  id: string;                                            // ID del campo, útil para accesibilidad y formularios
  name: string;                                          // Nombre del campo
  className?: string;                                    // Clases CSS adicionales opcionales
  disabled?: boolean;                                    // Si el select está deshabilitado
  onErrorChange?: (mensaje: string | null, tipo: string) => void; // Callback opcional para manejar mensajes de error externos
}

// Definición del componente funcional SelectDniNie
const SelectDniNie: React.FC<Props> = ({
  value,
  onChange,
  opciones,
  error,
  placeholder = "DNI / NIE",
  disabled = false,     // Valor por defecto: false
  id,
  name,
  className = '',       // Valor por defecto: cadena vacía
  onErrorChange,        // Función opcional para gestionar errores externos
}) => {

  // Función que maneja el cambio de selección del usuario
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = e.target.value; // Obtenemos el valor seleccionado

    // Si se proporciona la función onErrorChange, gestionamos los mensajes de error
    if (onErrorChange) {
      if (!selected) {
        // Si no se seleccionó nada, enviamos un mensaje de error
        onErrorChange('Debe seleccionar un tipo de documento.', 'dni');
      } else {
        // Si se seleccionó correctamente, limpiamos el mensaje de error
        onErrorChange(null, 'dni');
      }
    }

    // Notificamos el cambio de selección al componente padre
    onChange(selected);
  };

  // Renderizado del componente
  return (
    <div className="relative">
      {/* Componente Select personalizado */}
      <Select
        id={id}                                       // Identificador único
        name={name}                                   // Nombre del campo
        value={error ? '' : value}                    // Si hay error, se muestra el placeholder (valor vacío)
        onChange={handleSelectChange}                 // Lógica de cambio definida arriba
        options={opciones.map((opcion) => ({          // Mapeo de opciones para adaptarlas al formato esperado por Select
          value: opcion.toLowerCase(),                // Valor interno en minúsculas
          label: opcion,                              // Texto visible al usuario
        }))}
        disabled={disabled}                           // Deshabilitado si se indica
        placeholder={placeholder}                     // Texto placeholder
        className={`${error ? 'bg-red-100' : ''} ${className}`} // Fondo rojo claro si hay error + clases adicionales
      />
    </div>
  );
};

// Exportamos el componente para que pueda usarse en otros lugares
export default SelectDniNie;
